import {
  UPDATE_CANVAS,
} from '../actions/types';

export default function (state = {canvas: null, context: null, history:[]}, action) {
    switch (action.type) {
    case UPDATE_CANVAS:
        return action.payload;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/app/reducers/ts_canvas.js